import React, { FC } from 'react';
import { OWNER_ADDRESS_FAKE_INPUTS } from '../../../constants/merchant/owner-inputs';
import { useTranslation } from 'react-i18next';
import { MRT_Row } from 'material-react-table';
import { FakeInput } from '../../form/FakeInput';

export const OwnerDetailPanel: FC = (props: MRT_Row) => {
	const { t } = useTranslation();

	// @ts-ignore
	const data = props?.row?.original;

	const ADDRESS_INPUTS = OWNER_ADDRESS_FAKE_INPUTS({ t, data });
	return (
		<div className="row fc-table-panel py-5 pt-10">
			{
				ADDRESS_INPUTS.map(item => {
					return (
						<FakeInput
							{...item}
							key={item.key}
						/>
					);
				})
			}
		</div>
	);
};
